export function matchKeywords<T>(treeNode: T, content: string, keywordList: string[]) {
  return keywordList.every((keyword) => content.indexOf(keyword) > -1);
}

export default function treeListFilter<T extends any>(
  treeList: T[],
  keyword: string,
  options: {
    skipFilterChildren?: (treeNode: T) => boolean;
    contentBuilder?: (treeNode: T) => string;
    childrenAttributeName?: string;
    caseSensitive?: boolean;
    matchKeywordsCallback?: (treeNode: T, content: string, keywordList: string[]) => boolean;
  } = {},
) {
  const result: T[] = [];
  const {
    childrenAttributeName = 'children',
    caseSensitive = false,
    skipFilterChildren,
    contentBuilder = (treeNode: any) => treeNode.name,
    matchKeywordsCallback = matchKeywords,
  } = options;
  // eslint-disable-next-line no-param-reassign
  keyword = caseSensitive ? keyword : keyword.toLowerCase();
  const keywordList = keyword.split(' ').map((keywordItem) => keywordItem.trim());

  treeList.forEach((treeNode: any) => {
    if (treeNode[childrenAttributeName] && treeNode[childrenAttributeName].length > 0) {
      if (skipFilterChildren && skipFilterChildren(treeNode)) {
        let content = contentBuilder(treeNode);
        content = caseSensitive ? content : content.toLowerCase();
        if (matchKeywordsCallback(treeNode, content, keywordList)) {
          result.push(treeNode);
        }
      } else {
        const filteredChildren = treeListFilter(treeNode[childrenAttributeName], keyword, options);
        let content = contentBuilder(treeNode);
        content = caseSensitive ? content : content.toLowerCase();
        if (filteredChildren.length > 0 || content.indexOf(keyword) > -1) {
          result.push({
            ...treeNode,
            [childrenAttributeName]: filteredChildren,
          });
        }
      }
    } else {
      let content = contentBuilder(treeNode);
      content = caseSensitive ? content : content.toLowerCase();
      if (matchKeywordsCallback(treeNode, content, keywordList)) {
        result.push(treeNode);
      }
    }
  });
  return result;
}
